<app-hero-section></app-hero-section>
<app-advertisement></app-advertisement>
<app-feature-product [featuredProducts]="featuredProducts"></app-feature-product>
<app-highlight></app-highlight>
<app-best-sellers-section
    [bestSellerProducts]="bestSellerProducts"
    *ngIf="bestSellerProducts.length"
></app-best-sellers-section>
<app-creativity></app-creativity>
<app-home-client-reviews></app-home-client-reviews>
<app-custom-blocks-cta></app-custom-blocks-cta>
